import { useState } from 'react';
import styled from 'styled-components';
import { createStore } from '../../api/stores';


const CATEGORY_OPTIONS = [
    '음식점', '카페', '미용', '의류', '의료', '교육', '스포츠', '숙박', '기타',
];

const StoreModal = ({ onClose, onSuccess }) => {
    const [폼, set폼] = useState({ name: '', category: '', bio: '' });
    const [저장중, set저장중] = useState(false);
    const [에러, set에러] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        set폼((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        set에러(null);
        set저장중(true);

        const body = {
            name: 폼.name,
            category: 폼.category,
            description: 폼.bio || undefined,
        };

        try {
            await createStore(body);
            onSuccess?.();
            onClose();
        } catch {
            set에러('저장 중 오류가 발생했습니다.');
        } finally {
            set저장중(false);
        }
    };

    return (
        <Overlay onClick={onClose}>
            <ModalCard onClick={(e) => e.stopPropagation()}>
                <ModalHeader>
                    <ModalTitle>스토어 추가</ModalTitle>
                    <CloseButton onClick={onClose}>✕</CloseButton>
                </ModalHeader>

                <Form onSubmit={handleSubmit}>
                    <Field>
                        <Label>스토어 이름 *</Label>
                        <Input
                            name="name"
                            placeholder="예: 홍길동 카페"
                            value={폼.name}
                            onChange={handleChange}
                            required
                        />
                    </Field>

                    <Field>
                        <Label>카테고리 *</Label>
                        <Select
                            name="category"
                            value={폼.category}
                            onChange={handleChange}
                            required
                        >
                            <option value="">선택하세요</option>
                            {CATEGORY_OPTIONS.map((opt) => (
                                <option key={opt} value={opt}>{opt}</option>
                            ))}
                        </Select>
                    </Field>

                    <Field>
                        <Label>소개</Label>
                        <Input
                            name="bio"
                            placeholder="간단한 소개 (선택)"
                            value={폼.bio}
                            onChange={handleChange}
                        />
                    </Field>

                    {에러 && <ErrorText>{에러}</ErrorText>}

                    <ButtonRow>
                        <CancelButton type="button" onClick={onClose}>
                            취소
                        </CancelButton>
                        <SubmitButton type="submit" disabled={저장중}>
                            {저장중 ? '저장 중...' : '저장'}
                        </SubmitButton>
                    </ButtonRow>
                </Form>
            </ModalCard>
        </Overlay>
    );
};


const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 24px;
    box-sizing: border-box;
`;

const ModalCard = styled.div`
    width: 100%;
    max-width: 440px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    border-radius: 16px;
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

const ModalHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const ModalTitle = styled.h2`
    font-family: Pretendard;
    font-size: 18px;
    font-weight: 700;
    color: #111111;
    margin: 0;
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 16px;
    color: #aaaaaa;
    cursor: pointer;
    padding: 4px;
    line-height: 1;

    &:hover {
        color: #333333;
    }
`;

const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

const Label = styled.label`
    font-family: Pretendard;
    font-size: 12px;
    font-weight: 500;
    color: #777777;
`;

const inputBase = `
    background: #f7f8fa;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 10px 12px;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 400;
    color: #111111;
    outline: none;
    width: 100%;
    box-sizing: border-box;

    &::placeholder {
        color: #c0c0c0;
    }

    &:focus {
        border-color: #487BFD;
    }
`;

const Input = styled.input`${inputBase}`;

const Select = styled.select`
    ${inputBase}
    appearance: none;
    cursor: pointer;
`;

const ErrorText = styled.span`
    font-family: Pretendard;
    font-size: 13px;
    color: #EF4444;
`;

const ButtonRow = styled.div`
    display: flex;
    gap: 8px;
    justify-content: flex-end;
`;

const CancelButton = styled.button`
    background: none;
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    padding: 10px 20px;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 500;
    color: #777777;
    cursor: pointer;
    transition: border-color 0.15s, color 0.15s;

    &:hover {
        border-color: #bbbbbb;
        color: #333333;
    }
`;

const SubmitButton = styled.button`
    background: #487BFD;
    border: none;
    border-radius: 8px;
    padding: 10px 24px;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    cursor: pointer;
    transition: opacity 0.15s;

    &:hover:not(:disabled) {
        opacity: 0.85;
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }
`;


export default StoreModal;
